import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  return (
    <footer
      className="border-t mt-auto"
      style={{ background: 'var(--bg-secondary)', borderColor: 'var(--border)' }}>

      {/* Row 1 */}
      <div className="max-w-8xl mx-auto px-6 pt-12 pb-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <AppLogo size={28} />
              <span className="font-display font-semibold text-base" style={{ color: 'var(--text-primary)' }}>ZyForge

              </span>
            </div>
            <p className="text-sm leading-relaxed" style={{ color: 'var(--text-muted)' }}>
              Premium website templates for every platform. Launch faster.
            </p>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-widest mb-3" style={{ color: 'var(--text-muted)' }}>
              Marketplace
            </p>
            <div className="flex flex-col gap-2">
              {[
              { href: '/templates', label: 'All Templates' },
              { href: '/template-detail', label: 'Featured' },
              { href: '/faq', label: 'FAQ' },
              { href: '/checkout', label: 'Checkout' }].
              map((l) =>
              <Link
                key={l.href}
                href={l.href}
                className="text-sm transition-colors hover:text-accent"
                style={{ color: 'var(--text-secondary)' }}>

                  {l.label}
                </Link>
              )}
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-widest mb-3" style={{ color: 'var(--text-muted)' }}>
              Account
            </p>
            <div className="flex flex-col gap-2">
              {[
              { href: '/sign-up-login', label: 'Sign In' },
              { href: '/account-dashboard', label: 'Dashboard' },
              { href: '/community', label: 'Community' },
              { href: '/community/faq', label: 'Community FAQ' }].
              map((l) =>
              <Link
                key={l.href}
                href={l.href}
                className="text-sm transition-colors"
                style={{ color: 'var(--text-secondary)' }}>

                  {l.label}
                </Link>
              )}
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-widest mb-3" style={{ color: 'var(--text-muted)' }}>
              Platforms
            </p>
            <div className="flex flex-col gap-2">
              {['Shopify', 'WordPress', 'WooCommerce', 'HTML / CSS'].map((p) =>
              <span key={p} className="text-sm" style={{ color: 'var(--text-secondary)' }}>
                  {p}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Row 2 */}
      <div
        className="border-t"
        style={{ borderColor: 'var(--border)' }}>

        <div className="max-w-8xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs" style={{ color: 'var(--text-muted)' }}>© 2026 ZyForge. All rights reserved.

          </p>
          <div className="flex items-center gap-4">
            <Link href="#" className="text-xs transition-colors" style={{ color: 'var(--text-muted)' }}>
              Privacy Policy
            </Link>
            <Link href="#" className="text-xs transition-colors" style={{ color: 'var(--text-muted)' }}>
              Terms of Service
            </Link>
            <div className="flex items-center gap-2 ml-2">
              {[
              { icon: 'GlobeAltIcon', label: 'Website' }].
              map((s) =>
              <a
                key={s.label}
                href="#"
                aria-label={s.label}
                className="w-7 h-7 rounded-lg flex items-center justify-center transition-colors"
                style={{ color: 'var(--text-muted)', background: 'var(--bg-card)', border: '1px solid var(--border)' }}>

                  <Icon name={s.icon as 'GlobeAltIcon'} size={13} />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>);

}